// extracted by mini-css-extract-plugin
module.exports = {"container":"_53c38bc4","block":"_cda9498a"};